import { useEffect } from "react";

const SITE = "Le Stand d'Or";

export function useSEO(title, description) {
  useEffect(() => {
    document.title = title ? `${title} — ${SITE}` : SITE;
    if (description) {
      const el = document.querySelector('meta[name="description"]');
      if (el) el.setAttribute("content", description);
    }
    return () => {
      document.title = SITE;
    };
  }, [title, description]);
}
